import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon, GithubIcon } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  description: string;
  technologies: string[];
  color: 'teal' | 'orange' | 'purple' | 'green' | 'blue' | 'pink';
  delay?: number;
  githubLink?: string;
  liveLink?: string;
}
export function ProjectCard({
  title,
  description,
  technologies,
  color,
  delay = 0,
  githubLink,
  liveLink
}: ProjectCardProps) {
  const colorClasses = {
    teal: 'from-teal-500/20 to-teal-500/5 border-teal-500/30 hover:border-teal-500/60',
    orange: 'from-orange-500/20 to-orange-500/5 border-orange-500/30 hover:border-orange-500/60',
    purple: 'from-purple-500/20 to-purple-500/5 border-purple-500/30 hover:border-purple-500/60',
    green: 'from-green-500/20 to-green-500/5 border-green-500/30 hover:border-green-500/60',
    blue: 'from-blue-500/20 to-blue-500/5 border-blue-500/30 hover:border-blue-500/60',
    pink: 'from-pink-500/20 to-pink-500/5 border-pink-500/30 hover:border-pink-500/60'
  };
  const tagColorClasses = {
    teal: 'bg-teal-500/10 text-teal-400 border-teal-500/30',
    orange: 'bg-orange-500/10 text-orange-400 border-orange-500/30',
    purple: 'bg-purple-500/10 text-purple-400 border-purple-500/30',
    green: 'bg-green-500/10 text-green-400 border-green-500/30',
    blue: 'bg-blue-500/10 text-blue-400 border-blue-500/30',
    pink: 'bg-pink-500/10 text-pink-400 border-pink-500/30'
  };
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={{
    y: -8,
    transition: {
      duration: 0.2
    }
  }} className={`bg-gradient-to-br ${colorClasses[color]} border rounded-xl p-6 backdrop-blur-sm transition-all cursor-pointer group`} data-id="element-113">
      <div className="flex items-start justify-between mb-4" data-id="element-114">
        <h3 className="text-xl font-bold text-slate-100 group-hover:text-teal-400 transition-colors" data-id="element-115">
          {title}
        </h3>
        <div className="flex gap-2" data-id="element-116">
          {githubLink && <motion.a href={githubLink} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.1
        }} whileTap={{
          scale: 0.95
        }} className="p-2 bg-slate-700/50 hover:bg-slate-700 rounded-lg transition-colors" aria-label={`View ${title} on GitHub`} data-id="element-117">
              <GithubIcon className="h-4 w-4 text-slate-400" aria-hidden="true" data-id="element-118" />
            </motion.a>}
          {liveLink && <motion.a href={liveLink} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.1
        }} whileTap={{
          scale: 0.95
        }} className="p-2 bg-slate-700/50 hover:bg-slate-700 rounded-lg transition-colors" aria-label={`View ${title} live demo`} data-id="element-119">
              <ExternalLinkIcon className="h-4 w-4 text-slate-400" aria-hidden="true" data-id="element-120" />
            </motion.a>}
        </div>
      </div>

      <p className="text-slate-300 text-sm leading-relaxed mb-4" data-id="element-121">{description}</p>

      <div className="flex flex-wrap gap-2" data-id="element-122">
        {technologies.map(tech => <span key={tech} className={`px-3 py-1 text-xs font-medium ${tagColorClasses[color]} border rounded-full font-mono`} data-id="element-123">
            {tech}
          </span>)}
      </div>
    </motion.div>;
}